import React from "react";
import {
  Container,
  Typography,
  Box,
  Grid,
  Card,
  CardContent,
  useTheme,
  alpha,
  Chip,
  Button,
  Stack,
  List,
  ListItem,
  ListItemIcon,
  ListItemText
} from "@mui/material";
import {
  CheckCircle as CheckIcon,
  Schedule as ScheduleIcon,
  Security as SecurityIcon,
  Star as StarIcon
} from "@mui/icons-material";

const Compliance = () => {
  const theme = useTheme();

  const features = [
    "Turnkey cleaning between guest stays",
    "Linen and amenity restocking",
    "Quality inspection checklist",
    "Quick turnaround (2-4 hours)",
    "Photo documentation",
    "24/7 emergency support"
  ];

  const pricing = [
    { type: "Studio", price: "$79", description: "Perfect for studio apartments" },
    { type: "1-Bedroom", price: "$99", description: "Ideal for 1-bedroom listings" },
    { type: "2-Bedroom", price: "$149", description: "Great for 2-bedroom properties" },
    { type: "3+ Bedroom", price: "$199+", description: "For larger properties" }
  ];

  return (
    <Container maxWidth="lg" sx={{ py: 8 }}>
      {/* Hero Section */}
      <Box sx={{ textAlign: "center", mb: 8 }}>
        <Chip 
          label="🏠 Airbnb Specialized" 
          sx={{ 
            mb: 3,
            background: alpha(theme.palette.primary.main, 0.1),
            color: theme.palette.primary.dark,
            fontWeight: 600,
            fontSize: "0.85rem"
          }}
        />
        <Typography
          variant="h2"
          sx={{
            fontWeight: 700,
            color: theme.palette.text.primary,
            mb: 3,
            fontSize: { xs: "2.5rem", md: "3rem" }
          }}
        >
          Airbnb Cleaning Services
        </Typography>
        <Typography
          variant="h6"
          sx={{
            color: theme.palette.text.secondary,
            maxWidth: "800px",
            mx: "auto",
            lineHeight: 1.6,
            fontSize: "1.1rem"
          }}
        >
          Professional cleaning services specifically designed for Airbnb hosts. 
          Fast, reliable turnover cleaning that ensures 5-star reviews and happy guests.
        </Typography>
      </Box>

      <Grid container spacing={6}>
        <Grid item xs={12} md={6}>
          <Typography variant="h4" gutterBottom sx={{ fontWeight: 700, mb: 3 }}>
            Why Choose Our Airbnb Cleaning?
          </Typography>
          
          <List sx={{ mb: 4 }}>
            {features.map((feature, index) => (
              <ListItem key={index} sx={{ px: 0 }}>
                <ListItemIcon sx={{ minWidth: 40 }}>
                  <CheckIcon sx={{ color: theme.palette.primary.main }} />
                </ListItemIcon>
                <ListItemText 
                  primary={feature}
                  primaryTypographyProps={{ fontWeight: 500 }}
                />
              </ListItem>
            ))}
          </List>

          <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
            <Button variant="contained" size="large">
              Book Now
            </Button>
            <Button variant="outlined" size="large">
              View Pricing
            </Button>
          </Stack>
        </Grid>

        <Grid item xs={12} md={6}>
          <Typography variant="h4" gutterBottom sx={{ fontWeight: 700, mb: 3 }}>
            Transparent Pricing
          </Typography>
          
          <Grid container spacing={2}>
            {pricing.map((item, index) => (
              <Grid item xs={12} sm={6} key={index}>
                <Card sx={{ textAlign: "center", background: theme.palette.background.paper }}>
                  <CardContent sx={{ p: 3 }}>
                    <Typography variant="h5" fontWeight="700" color={theme.palette.primary.main} gutterBottom>
                      {item.price}
                    </Typography>
                    <Typography variant="h6" fontWeight="600" gutterBottom>
                      {item.type}
                    </Typography>
                    <Typography variant="body2" color={theme.palette.text.secondary}>
                      {item.description}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
};

export default Compliance;